import { MainState } from './model/main-state.model';

const stateWrapper: {
    mainState: MainState | null;
} = {
    mainState: null,
};

export const currentMainState = (): MainState => stateWrapper.mainState;

export const defaultMainState = (): void => {
    stateWrapper.mainState = {};
};
